// Universal per-file upload limit (5 MB), enforced app-wide.
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;
export const MAX_UPLOAD_MB = 5;

// Tiny pub/sub so any oversized-file rejection (early UI checks or the axios
// safety net) opens a single shared modal, instead of a toast or a crash.
const listeners = new Set();

export function subscribeFileTooLarge(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function notifyFileTooLarge(mb) {
  listeners.forEach((cb) => cb(mb));
}

/** Returns true if the file is within the limit; otherwise opens the shared
 *  "file too large" modal and returns false. Use in upload handlers before
 *  sending so the user is stopped immediately. */
export function checkFileSize(file) {
  if (file && file.size > MAX_UPLOAD_BYTES) {
    const mb = (file.size / (1024 * 1024)).toFixed(1);
    notifyFileTooLarge(mb);
    return false;
  }
  return true;
}
